// Zero-backend donate link: an external link to a hosted donation page.
// To change the destination, just edit DONATE_URL (e.g. a different Ko-fi /
// BuyMeACoffee / Stripe page). Leave it as a "REPLACE_ME" value to hide the
// donate UI entirely.
export const DONATE_URL = "https://ko-fi.com/achtungroyale";

// Donate entry points render only once a real URL is configured.
export const DONATE_ENABLED = !DONATE_URL.includes("REPLACE_ME");

// Single hook for analytics once it lands (#35). No-op until then.
export function trackDonateClick(source: "nav" | "match-over"): void {
  try {
    (window as any).plausible?.("donate_click", { props: { source } });
  } catch {
    /* never let tracking break a click */
  }
}
